import { Action } from '../../../common/actions/core/action';

export class OpenStudentNoSubAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/nosub/nosub.action.ts